import { Stack } from '@mui/material';

import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

export function GuarantorFormFields() {
  return (
    <>
      <Stack direction="column" spacing={2}>
        <ParentBlockSelectField
          fieldName="config.patient.sourceBlockName"
          label="Patient Source"
          required
          helperText={getSourceBlockNameHelperText('patient')}
        />
      </Stack>
    </>
  );
}
